import { computed, observable, action, autorun, reaction } from 'mobx';
import { History } from 'history';
import { User } from '@/model/user';
import { Agency } from '@/model/agency';

// 放置全局Store，比如登录用户
class GlobalStore {
  @observable account: User = {} as User;
  history: History = {} as History;
  @observable loading = new Map<string, boolean>();
  @observable loadingCount = 0;
  @observable pageNoticeConfig: Record<string, any> = {};
  @observable navBreathingLight: Record<string, boolean> = {};

  @computed
  get currentUserId(): number {
    return this.account ? this.account.user_id || 0 : 0;
  }

  @computed
  get userAgencyList(): Agency[] {
    return this.account ? this.account.agency_list || [] : [];
  }

  @action
  setAccount(account: User): void {
    if (account) {
      this.account = account;
    }
  }

  @action
  setHistory(history: History): void {
    if (history) {
      this.history = history;
    }
  }

  @computed
  get isLoading(): boolean {
    return this.loadingCount > 0;
  }

  @action
  openLoading(key: string): void {
    if (key) {
      this.loading.set(key, true);
      this.loadingCount += 1;
    }
  }

  @action
  closeLoading(key: string): void {
    if (key) {
      this.loading.set(key, false);
      this.loadingCount -= 1;
    }
  }

  @action
  setPageNoticeConfig(data: Record<string, any>): void {
    this.pageNoticeConfig = data;
  }

  @action
  setNavBreathingLight(key: string, value: boolean): void {
    if (key) {
      this.navBreathingLight[key] = value;
    }
  }
}

const globalStore = new GlobalStore();

$(document).ajaxSend((event: any, xhr: any, ajaxOptions: any) => {
  if (ajaxOptions.key) {
    globalStore.openLoading(ajaxOptions.key);
  }
});

$(document).ajaxComplete((event: any, xhr: any, ajaxOptions: any) => {
  if (ajaxOptions.key) {
    globalStore.closeLoading(ajaxOptions.key);
  }
});

export default globalStore;
